import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

export default function useSubscriptionList() {
  const navigate = useNavigate();

  const handleDetailPage = useCallback(
    (templateId: string) => {
      navigate(`/template/${templateId}`);
    },
    [navigate]
  );

  return {
    handleDetailPage,
  };
}
